module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('input-mask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "itemGroups"
    }
  }, [_vm._v("Item Category")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "dropdown-custom",
    attrs: {
      "options": _vm.itemGroups,
      "optionLabel": "name",
      "placeholder": "Select Category"
    },
    on: {
      "change": _vm.filterItemsByGroup
    },
    model: {
      value: (_vm.selectedGroup),
      callback: function($$v) {
        _vm.selectedGroup = $$v
      },
      expression: "selectedGroup"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "items"
    }
  }, [_vm._v("Items")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "multiselect-custom",
    attrs: {
      "options": _vm.filteredItems,
      "optionLabel": "name",
      "placeholder": "Select Items",
      "showCheckbox": true,
      "filter": true
    },
    on: {
      "filter": _vm.searchItems
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-multiselect-item-option"
        }, [_c('span', [_vm._v(_vm._s(slotProps.option.name))])])]
      }
    }]),
    model: {
      value: (_vm.selectedItems),
      callback: function($$v) {
        _vm.selectedItems = $$v
      },
      expression: "selectedItems"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Search",
      "icon": "pi pi-search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchItemMargin.apply(null, arguments)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [(_vm.itemMarginData.length > 0) ? _c('a', {
    staticClass: "p-field p-col-12 p-md-12",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right",
      "height": "3em",
      "width": "3em"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.itemMarginData,
      "paginator": true,
      "rows": 100,
      "filters": _vm.filters,
      "rowsPerPageOptions": [100, 500, 1000],
      "data-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n                " + _vm._s(sl.index + 1) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Sales Date",
      "sortable": true,
      "field": "salesDateEnglish",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDateEnglish']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDateEnglish', $$v)
            },
            expression: "filters['salesDateEnglish']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "sortable": true,
      "field": "billNo",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billNo']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billNo', $$v)
            },
            expression: "filters['billNo']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer",
      "sortable": true,
      "field": "accountName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['accountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'accountName', $$v)
            },
            expression: "filters['accountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Item Name",
      "sortable": true,
      "field": "itemName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['itemName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'itemName', $$v)
            },
            expression: "filters['itemName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Item Code",
      "sortable": true,
      "field": "itemCode",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['itemCode']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'itemCode', $$v)
            },
            expression: "filters['itemCode']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Purchase Rate",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "purchaseRate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.purchaseRate.toFixed(2)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Sales Rate",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "salesRate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.salesRate.toFixed(2)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Margin",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "margin",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.margin.toFixed(2)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Margin %",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "marginPercent",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['marginPercent']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'marginPercent', $$v)
            },
            expression: "filters['marginPercent']"
          }
        })]
      },
      proxy: true
    }, {
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.marginPercent.toFixed(2)) + "%\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Profit %",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "grossMargin",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.grossMargin.toFixed(2)) + "%\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Vat To Pay",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "vatTopay",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.vatTopay.toFixed(2)) + "\n              ")]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalVatToPay.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Commission",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "commissionAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.commissionAmount.toFixed(2)) + "\n              ")]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalCommissionAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Total Profit",
      "bodyStyle": "text-align: right",
      "sortable": true,
      "field": "totalMargin",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                " + _vm._s(slotProps.data.totalMargin.toFixed(2)) + "\n              ")]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalMarginSum.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Org Name",
      "sortable": true,
      "field": "orgName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['orgName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'orgName', $$v)
            },
            expression: "filters['orgName']"
          }
        })]
      },
      proxy: true
    }])
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fa33a46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/analysisReport/profitReportGross.vue
// module id = 2263
// module chunks = 0